import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useRoutes,
} from "react-router-dom";
import { SnackbarProvider } from "notistack";

import Home from "./pages/home.js";
import JoinUs from "./pages/joinus.js";
import Login from "./pages/login.js";
import ForgotPassword from "./pages/forgotpassword.js";
import Referral_page from "./pages/referral_page.js";
import ResetPassword from "./pages/resetpassword.js";
import Privacy from "./pages/privacypage.js";
import Terms from "./pages/terms.js";
import KYCPage from "./pages/kycpage.js";
import Token from "./pages/token.js";
import "@fortawesome/fontawesome-free/css/all.min.css";
import PrivateRoute from "./privateRoutes.js";
import Buytoken_page from "./pages/buytoken.js";

import { WagmiConfig } from 'wagmi'


import { WalletProvider } from './pages/walletconnect/walletContext.js'

const App = () => {
  const routes = useRoutes([
    { path: "/", element: <Home /> },
    { path: "/joinus/:Id", element: <JoinUs /> },
    { path: "/joinus", element: <JoinUs /> },
    { path: "/login", element: <Login /> },
    { path: "/forgotpassword", element: <ForgotPassword /> },
    {
      path: "/dashboard",
      element: (
        <PrivateRoute>
          <Referral_page />
        </PrivateRoute>
      ),
    },
    { path: "/reset-password/:id", element: <ResetPassword /> },
    { path: "/privacy", element: <Privacy /> },
    { path: "/Terms", element: <Terms /> },
    {
      path: "/kyc",
      element: (
        <PrivateRoute>
          <KYCPage />
        </PrivateRoute>
      ),
    },
    { path: "/token", element: <Token /> },
    {
      path: "/buytoken",
      element: (
        <PrivateRoute>
          <Buytoken_page />
        </PrivateRoute>
      ),
    },
  ]);
  return routes;
};

const AppWrapper = () => {
  return (
    <Router basename="/">

      <WalletProvider>
        <SnackbarProvider />
        <App />
      </WalletProvider>

    </Router>
  );
};

export default AppWrapper;
